export default __webpack_public_path__ + "static/media/atlassian-logo.ac676f72.svg";